export const AIRPORT_TRANSFER_CURRENCY = 'EUR';
export const AIRPORT_TRANSFER_VEHICLE = 'Mercedes-Benz V-Class';

export const AIRPORT_TRANSFER_OPTIONS = Object.freeze({
  tivat: Object.freeze({ price: 100 }),
  podgorica: Object.freeze({ price: 120 }),
});

export function normalizeAirportTransfer(value) {
  const requested = value?.requested === true;
  const airport = typeof value?.airport === 'string' && AIRPORT_TRANSFER_OPTIONS[value.airport]
    ? value.airport
    : '';
  const flightNumber = typeof value?.flightNumber === 'string'
    ? value.flightNumber.trim().slice(0, 40)
    : '';

  return {
    requested,
    airport: requested ? airport : '',
    flightNumber: requested ? flightNumber : '',
  };
}

export function getAirportTransferPrice(value) {
  if (value?.requested !== true) return 0;
  return AIRPORT_TRANSFER_OPTIONS[value.airport]?.price || 0;
}
